import { createContext, useContext } from 'react'
import type { ListeningContext } from '../track'
import type {
  ReactionsData,
  ReactionsState,
  UseReactions
} from './useReactions'
import { useReactions } from './useReactions'

export type ReactionsContextValue = UseReactions | null

export const ReactionsContext = createContext<ReactionsContextValue>(null)

interface ReactionsContextProviderProps extends ReactionsData {
  children: JSX.Element
  myReactions: ReactionsState
  listeningContext: ListeningContext
}

export function ReactionsContextProvider(
  props: ReactionsContextProviderProps
): JSX.Element {
  const reactions = useReactions(
    {
      createdByUserId: props.createdByUserId,
      id: props.id,
      listeningContext: props.listeningContext
    },
    props.myReactions
  )
  return (
    <ReactionsContext.Provider value={reactions}>
      {props.children}
    </ReactionsContext.Provider>
  )
}

export function useReactionsContext(): UseReactions {
  const value = useContext(ReactionsContext)
  if (!value) {
    throw new Error('Missing ReactionsContext')
  }
  return value
}
